module.exports = __webpack_public_path__ + "img/birdlife-fr.6cb06017.svg";